import React from 'react';
import { Table } from 'antd';
import moment from 'moment';
import { Link } from 'react-router-dom';

import Breadcrumbs from '@sp/client/components/Breadcrumbs';
import NavBar from '@sp/client/components/NavBar';

import s from './style.less';

class CustomerPayments extends React.Component {
  state = {
    list: [],
  };

  componentDidMount() {
    this.fetchList();
  }

  breadcrumbs = [
    { name: 'Home', to: '/customer/plans' },
    { name: 'My Payments' },
  ];

  columns = [
    {
      title: 'Contract number',
      dataIndex: 'contractNumber',
      key: 'contract_number',
    },
    {
      title: 'Created',
      dataIndex: 'createdAt',
      key: 'created',
      render: date => moment(date).format('DD/MM/YYYY'),
    },
    {
      title: 'Full amount',
      key: 'fullAmount',
      dataIndex: 'paymentSum',
      render: paymentSum => (
        <span>
          &pound;
          {paymentSum.toFixed(2)}
        </span>
      ),
    },
    {
      title: 'Paid amount',
      key: 'paidAmount',
      dataIndex: 'paid',
      render: (paid, row) => (
        <span>
          <Link to={`/customer/payments/${row.id}`}>
            &pound;
            {row.paid.toFixed(2)}
          </Link>
        </span>
      ),
    },
  ];

  fetchList = async () => {
    const list = await fetch('/customer/my-payments');
    this.setState({ list });
  };

  render() {
    const { list } = this.state;

    return (
      <NavBar withPadding>
        <Breadcrumbs paths={this.breadcrumbs} />
        <div className={s.title}>Payments</div>
        <Table columns={this.columns} rowKey="id" dataSource={list} />
      </NavBar>
    );
  }
}

export default CustomerPayments;
